<template>
  <div class="soft-detail-wrap">
    <div class="soft-detail">
      <main :style="{transform: 'scale('+(multiple<1?multiple:1)+')'}">
        <div class="close" @click="close"><i class="el-icon-close"></i></div>
        <div class="soft-detail-left">
          <div class="title">{{ $theme ? obj.title : obj.titleEng }}</div>
          <div class="content">
            <img v-if="obj.title" :src="require(`@/assets/img/product/${obj.title}.png`)"
                 :class="isBright?' bright':''">
          </div>
        </div>
        <div class="soft-detail-right">
          <div class="right-main">
            <div class="title">
              {{ $theme ? '产品概述' : 'Product overview' }}
            </div>
            <div class="desc">
              {{ $theme ? obj.overview : obj.overviewEng }}
            </div>
            <div :class="`funcs ${funcs.length % 2 === 0?'':' single'}`">
              <div v-for="func in funcs" :key="func.id"
                   :class="`func${func.id === activeFunc?' active':''}`"
                   @mouseenter="activeFunc = func.id">
                <div class="top">
                  <img :src="require(`@/assets/img/product/icon/${func.id}.png`)">
                  <span>{{ func.title }}</span>
                </div>
                <div class="text">
                  {{ func.desc }}
                </div>
              </div>
            </div>
            <div class="divider"></div>
            <div :class="`adv${$theme?'':' eng'}`">
              <div class="title">
                {{ $theme ? '产品优势' : 'Product advantage' }}
              </div>
              <div class="row">
                <div
                    @mouseenter="activeAdv = item.id"
                    class="list-item"
                    :class="{ 'active-list': activeAdv === item.id }"
                    v-for="item in advantages"
                    :key="item.id"
                    :style="{left: activeAdv < item.id ? item.activeLeft : item.left}"
                >
                  <div class="title-wrap">
                    <div :class="`${$theme?'chn-title':'eng-title'}`">{{ item.title }}</div>
                  </div>
                  <div class="desc">
                    <div v-if="!$theme" class="desc-title">{{ item.title }}</div>
                    {{ item.desc }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: "SoftDetail",
  components: {},
  props: {
    obj: {
      type: Object,
      default() {
        return {
          title: ''
        }
      }
    }
  },
  data() {
    return {
      title: null,
      activeFunc: 1,
      activeAdv: 1,
      advantages: [],
      funcs: [],
      multiple: 1,
      bright: ['群防群治管理平台', '大气环境监测预警平台', '水环境监测预警平台', '危固废动态管理平台', '智慧应急综合预警研判系统', '公安警情大数据智能研判作战平台', '安防小区管控平台']
    };
  },
  computed: {
    isBright() {
      if (!this.obj?.title) return false
      return !this.bright.includes(this.obj.title)
    }
  },
  created() {
  },
  watch: {},
  mounted() {
    window.addEventListener('resize', this.onWindowResize, false)
    this.$nextTick(() => {
      this.onWindowResize()
    })
    // console.log(this.obj)
    const functionList = this.$theme ? this.obj.function : this.obj.functionEng
    functionList.split('\r\n').map((item, index) => {
      if (index % 2 === 0) {
        this.funcs.push({})
        this.funcs[Math.floor(index / 2)].title = item
      } else {
        this.funcs[Math.floor(index / 2)].desc = item
      }
    });
    this.funcs = this.funcs.map((item, index) => ({
      ...item,
      id: index + 1
    })).slice(0, 6)
    const advantageList = this.$theme ? this.obj.advantage : this.obj.advantageEng
    advantageList.split('\r\n').map((item, index) => {
      if (index % 2 === 0) {
        this.advantages.push({})
        this.advantages[Math.floor(index / 2)].title = item
      } else {
        this.advantages[Math.floor(index / 2)].desc = item
      }
    });
    this.advantages = this.advantages.map((item, index) => ({
      ...item,
      id: index + 1,
      left: index * 80 + "px",
      activeLeft: (index === 0 ? 0 : (index - 1) * 80 + 522) + "px"
    })).slice(0, 4)
  },
  methods: {
    onWindowResize() {
      const width = document.body.clientWidth;
      this.multiple = width / 1920
      if (!this.scene) {
        return
      }
      const viewer = this.$refs.viewer
      this.renderer.setSize(viewer.clientWidth, viewer.clientHeight)
      this.camera.aspect = viewer.clientWidth / viewer.clientHeight
      this.camera.updateProjectionMatrix()
    },
    init() {
    },
    close() {
      this.$emit('close')
    }
  }
};
</script>
<style lang="scss" scoped>
@import "Index";
</style>
